import React from "react";
import Button from "react-bootstrap/Button";
import styled from "styled-components";

const StyledBtn = styled(Button)`
  &.btn {
    font-weight: 400;
    border: 2px solid transparent;
    padding: 0.5rem 2rem;
    border-radius: 0.4rem;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -ms-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
  }
  &.btn:hover {
    -webkit-box-shadow: 0 0.2rem 1rem rgba(0, 0, 0, 0.2) !important;
    -moz-box-shadow: 0 0.2rem 1rem rgba(0, 0, 0, 0.2) !important;
    box-shadow: 0 0.2rem 1rem rgba(0, 0, 0, 0.2) !important;
  }
  &.btn:focus {
    box-shadow: none;
  }

  &.btn-group-sm > &.btn,
  &.btn-sm {
    font-weight: 400;
    border: 2px solid transparent;
    padding: 0.25rem 1.25rem;
    font-size: 0.875rem;
    line-height: 1.5;
    border-radius: 0.4rem;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -ms-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
  }
  &.btn-sm:hover {
    -webkit-box-shadow: 0 0.2rem 1rem rgba(0, 0, 0, 0.2) !important;
    -moz-box-shadow: 0 0.2rem 1rem rgba(0, 0, 0, 0.2) !important;
    box-shadow: 0 0.2rem 1rem rgba(0, 0, 0, 0.2) !important;
  }
  &.btn-group-lg > &.btn,
  &.btn-lg {
    font-weight: 700;
    padding: 0.75rem 2.5rem;
    font-size: 1.25rem;
    line-height: 1.5;
    border-radius: 0.4rem;
  }

  &.btn .icon-cta {
    font-size: 0.8rem;
    margin-left: 10px;
    opacity: 0;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -ms-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
  }
  &.btn:hover .icon-cta {
    font-size: 1rem;
    margin-left: 40px;
    opacity: 1;
  }
`;

export default StyledBtn;
